enum NodeType {
  ROOT = "ROOT",
  SUB = "SUB",
  MIXED = "MIXED",
}

export { NodeType };
